import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper } from '@fortawesome/free-solid-svg-icons';
import {
  NewsWidgetFactory,
  WidgetMenuEntry,
  NewsWidget,
  routeMatches,
} from '@/core/widgets/export';
import { PinnedSeriesWidget } from '@/modules/articles/widgets/pinned/pinned-series-widget';

export class TechnicalAnalysisWidgetFactory implements NewsWidgetFactory {
  getListableUrls(): WidgetMenuEntry[] {
    return [
      {
        name: 'Foreign Exchange Technical Analysis',
        url: '/pinned-series/mni-section:480257794',
      },
      {
        name: 'Fixed Income Technical Analysis',
        url: '/pinned-series/mni-section:480257793',
      },
      {
        name: 'Energy Technical Analysis',
        url: '/pinned-series/mni-section:561375839',
      },
    ];
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faNewspaper} /> Technical Analysis
      </>
    );
  }

  matchesTemplate(s: string): boolean {
    return !!routeMatches(this.path, s);
  }

  createInstance(s: string, customTitle?: string): NewsWidget {
    const match = routeMatches(this.path, s);

    if (match) return new PinnedSeriesWidget(match.genreQCode, false, customTitle);

    throw new Error('invalid url');
  }

  get path(): string {
    return '/pinned-series/:genreQCode';
  }

  internalPaths(): string[] {
    return ['/pinned-series/:genreQCode/list', '/pinned-series/:genreQCode/list/:id'];
  }
}
